import {UNIT_SKIP_MARK_BLINK} from '../../configs/unitSkipMarkAnimation';

// Мягкий разгон и торможение внутри окна буквы
const easeInOutSine = (t) => 0.5 - 0.5 * Math.cos(Math.PI * t);
const clamp01 = (value) => Math.min(Math.max(value, 0), 1);

/**
 * Прозрачность букв отметки пропуска хода «zzZ» по тому, насколько значок
 * поднят в покачивании (см. configs/unitSkipMarkAnimation): внизу (0) все
 * прозрачны, вверху (1) все видны целиком. Каждой букве отведено свое окно
 * подъема: на подъеме окна идут от маленькой буквы к большой, на спуске — тоже
 * от маленькой к большой (маленькая гаснет первой, у самого верха).
 * @param {number} lift — подъем значка от 0 (нижняя точка) до 1 (верхняя)
 * @param {boolean} isRising — значок поднимается (иначе опускается)
 * @param {number} letterCount — сколько букв в значке
 * @returns {number[]} alpha каждой буквы от 0 до 1, по порядку
 */
export const getUnitSkipMarkAlphas = (lift, isRising, letterCount) => {
  const span = UNIT_SKIP_MARK_BLINK.letterLiftSpan;
  const stagger = letterCount > 1 ? (1 - span) / (letterCount - 1) : 0;
  const safeLift = clamp01(Number.isFinite(lift) ? lift : 0);

  return Array.from({length: letterCount}, (item, index) => {
    // Окно буквы по подъему: на подъеме маленькая проявляется первой (окно
    // ниже), на спуске она же первой гаснет (окно выше)
    const order = isRising ? index : letterCount - 1 - index;
    const windowFrom = stagger * order;
    return easeInOutSine(clamp01((safeLift - windowFrom) / span));
  });
};
